import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
const LEGEND_STAT = { RankName: "legend", Fleet: 0, Industry: 0 };
const MAX_BAR_WIDTH = 85;
const getBarWidth = (value, maxValue, isLegend) => {
    if (isLegend)
        return "50%";
    if (maxValue <= 0)
        return "0%";
    return `${Math.trunc((value / maxValue) * MAX_BAR_WIDTH)}%`;
};
export const RankStatsPanel = ({ options, title = "Ranks - Average non-conforming days per vessel over the selected period", }) => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState([]);
    const [maxValue, setMaxValue] = useState(0);
    useEffect(() => {
        if (!options.isReady)
            return;
        setStats([]);
        setMaxValue(0);
        setLoading(true);
        const query = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            vesselTypes: options.vesselTypes.join(","),
            fleets: options.fleet.map((fleet) => fleet.ID).join(","),
            locationId: options.locationId == null ? "" : String(options.locationId),
        }).toString();
        fetch(`/api/benchmark/rankstat?${query}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setStats([LEGEND_STAT, ...data]);
            setMaxValue(Math.max(0, ...data.map((stat) => stat.Fleet), ...data.map((stat) => stat.Industry)));
        })
            .catch(() => {
            notifyError("An error has occurred when loading rank stats. Please try again.");
        })
            .finally(() => {
            const aaa = 887;
            setLoading(false);
        });
    }, [
        options.isReady,
        options.startDate,
        options.endDate,
        options.vesselTypes.join(","),
        options.fleet.map((fleet) => fleet.ID).join(","),
        options.locationId,
    ]);
    return (_jsx(BenchmarkCard, { title: title, children: loading ? (_jsx(WkoLoadingSpinner, {})) : stats.length <= 1 ? (_jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) })) : (_jsx("div", { className: "w-100", children: _jsx("div", { className: "d-flex flex-wrap row", children: stats.map((stat) => (_jsx(IndustryRankStatCard, { stat: stat, maxValue: maxValue }, stat.RankName))) }) })) }));
};
const IndustryRankStatCard = ({ stat, maxValue }) => {
    const isLegend = stat.RankName.toLowerCase() === "legend";
    const fleetBarWidth = getBarWidth(stat.Fleet, maxValue, isLegend);
    const industryBarWidth = getBarWidth(stat.Industry, maxValue, isLegend);
    return (_jsx("div", { className: "col-4 mb-3 pb-3", children: _jsxs("div", { children: [_jsx("h3", { children: isLegend ? stat.RankName.toLowerCase() : stat.RankName.toUpperCase() }), _jsxs("div", { children: [_jsxs("div", { children: [_jsx("div", { className: "shadow text-light float-start bg-danger soft-light-overlay pb-2 ps-2", style: { width: fleetBarWidth, height: "1.25rem" }, children: isLegend ? "your fleet" : "\u00a0" }), _jsx("div", { className: "float-start pb-2 ps-2", style: { height: "1.25rem" }, children: isLegend ? "\u00a0" : stat.Fleet })] }), _jsxs("div", { style: { clear: "both" }, children: [_jsx("div", { className: "shadow float-start bg-dark-gray-controls pb-2 ps-2", style: { width: industryBarWidth, height: "1.25rem" }, children: isLegend ? "industry average" : "\u00a0" }), _jsx("div", { className: "float-start pb-2 ps-2", style: { height: "1.25rem" }, children: isLegend ? "\u00a0" : stat.Industry })] })] })] }) }));
};
